module.exports = __webpack_public_path__ + "static/media/app_logo.3f412a09.png";